import { Dropdown, Modal, PrimaryButton } from "@fluentui/react";
import React, { useEffect, useState, useContext } from "react";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { useTranslation } from "react-i18next";
import ModalMain from "../../../../../components/Modal/ModalMain";
import ModalFooter from "../../../../../components/Modal/ModalFooter";
import ModalHeader from "../../../../../components/Modal/ModalHeader";
import { assignRadForPeerReview, getPacsNodeForSending, getRadiologistForPeerReview, pullPacsStudyReport, sendToNodes } from "../../../../../service/StudyListService";
import studylistContext from "../../../../../context/studylist/StudylistContext";
import studyReportContext from "../../../../../context/studyreport/StudyReportContext";
import themeContext from "../../../../../context/theme/ThemeContext";
import loaderContext from "../../../../../context/loader/LoaderContext";
import toastContext from "../../../../../context/toast/ToastContext";
import { TAB_NAME, TOAST_TYPE } from "../../../../../constants/Constants";
import SearchableDropDown from "../../../../ReportTemplates/helper/SearchDropdown";
import OutsideClickHandler from 'react-outside-click-handler';

const PeerReviewAssignment = (props) => {
  const [loading, setLoading] = useState(false);
  const { ref, setLoaderRunning, showModal, setShowModal } = useContext(loaderContext);
  const [radiologistList, setRadiologistList] = useState([]);
  const [selectedRadiologistId, setSelectedRadiologistId] = useState([]);
  const [responseMessage, setResponseMessage] = useState("");
  const [t] = useTranslation();
  const { showToastv2 } = useContext(toastContext);
  const [radiologistFilteredItems, setRadiologistFilteredItems] = useState(radiologistList);

  const {setRefreshRequired,
    refreshRequired,
    dataQueryState,
    setDataQueryState,
} = useContext(studylistContext);
  
  let PrimaryButtonList = [
    {
      title: t("button.close"),
      onclick: () => props.setShowPeerReviewAssignmentModal(false),
    },
  ];

  console.log(props);

  const getPeerReviewer = async() =>{
    setLoading(true);
    const response = await getRadiologistForPeerReview(props.studyId, props.clientId, props.firmId);
    console.log("Getting radiologist for peer review :", response)
    if (response.status == 200 && response.data.result == "SUCCESS") {
      if(response.data.data != null && response.data.data != undefined && response.data.data.radiologists.length > 0){
        let radiologistListItem = [];
        response.data.data.radiologists.filter((radiologist) => radiologist.id != props.radiologistId).map((radiologist) => {
          radiologistListItem.push({
            key: radiologist.id,
            text: radiologist.firstName + " " + radiologist.lastName,
          });
        });
        setRadiologistList(radiologistListItem);
        setRadiologistFilteredItems(radiologistListItem);
        if(response.data.data.reviewerId){
          let rad = radiologistListItem.filter((rad)=>rad.key == response.data.data.reviewerId)
          setSelectedRadiologistId(rad[0].key);
        }
      } else {
        setResponseMessage("No Radiologist available!");
      }
      setLoading(false);
    } else {
      setLoading(false);
      showToastv2(TOAST_TYPE.INFO, response.data.message);
    }
    
  }

  const handleDropdownChange = (event, item) => {
    console.log(item);
    if (item) {
      setSelectedRadiologistId(item.key);
    }
    setRadiologistFilteredItems(radiologistList)
  };

  const handlePeerReviewAssignment = async() =>{
    console.log("assigning to peer reviewer ", selectedRadiologistId);
    if(selectedRadiologistId.length == 0){
      showToastv2(TOAST_TYPE.INFO, "Select Peer Reviewer!");
      return;
    }
    setLoaderRunning(true);
    ref.current.continuousStart();
    const response = await assignRadForPeerReview(props.studyId, selectedRadiologistId);
    console.log("Send to pacs response :", response)
    if(response.data.result === "SUCCESS"){
      showToastv2(TOAST_TYPE.SUCCESS, response.data.message);
      props.setShowPeerReviewAssignmentModal(false);
      setTimeout(() => {
        setRefreshRequired(() => {
          const newItem = { ...refreshRequired };
          newItem[TAB_NAME.REVIEWASSIGNED].alreadyLoaded = false;
          console.log(newItem);
          return newItem;
        });
      }, 10);

      let newData = dataQueryState?.data?.rows.filter(
        (row) => row.id !== props.studyId
      );
      setDataQueryState(() => {
        const newValue = {
          ...dataQueryState,
        };
        newValue.data.rows = newData;
        return newValue;
      });
    }else{
      showToastv2(TOAST_TYPE.ERROR, response.data.message ? response.data.message : "Some error occurred in assiging to radiologist");
    }
    setLoaderRunning(false);
    ref.current.complete();
  }

  useEffect(() => {
    getPeerReviewer();
  }, []);

  const modalDetails = {
    header: (
      <ModalHeader
        updatedModal={true}
        heading={`${t("study-list.actions.peer-review-assignment")}`}
        handleCancel={() => props.setShowPeerReviewAssignmentModal(false)}
      />
    ),
    body: (
      <PeerReviewAssignmentModal
        radiologistList={radiologistList}
        responseMessage={responseMessage}
        loading={loading}
        setShowPeerReviewAssignmentModal={props.setShowPeerReviewAssignmentModal}
        handleDropdownChange={handleDropdownChange}
        selectedRadiologistId={selectedRadiologistId}
        setSelectedRadiologistId={setSelectedRadiologistId}
        handlePeerReviewAssignment={handlePeerReviewAssignment}
        radiologistFilteredItems={radiologistFilteredItems}
        setRadiologistFilteredItems={setRadiologistFilteredItems}
      />
    ),
    footer: (
      <ModalFooter
        PrimaryButtonList={[]}
        DefaultButtonList={PrimaryButtonList}
      />
    ),
    width: "400px",
  };

  return (
    <>
      <ModalMain
        updatedModal = {true}
        modalDetails={modalDetails}
        showModal={props.showPeerReviewAssignmentModal}
      />
    </>
  );
};

export default PeerReviewAssignment;

export const PeerReviewAssignmentModal = (props) => {
  const [t] = useTranslation();
  const { getThemeColor } = useContext(themeContext);

  const dropDownStyle = {
    dropdown: {
      width: "100%"
    },
    dropdownItemSelected: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
    },
    dropdownItemsWrapper: {
      maxHeight: "300px",
      overflowY: 'auto',
    },
    dropdownItem: {
      fontSize: "12px",
      lineHeight: "18px",
      fontWeight: "600",
      color: "white"
    },
  };

  const noReason = {
    padding: "10px",
    textAlign: "center",
    color: getThemeColor("primary-color"),
  };

  const customSpinnerStyle = {
    circle: {
      height: "20px",
      width: "20px",
      borderWidth: "3px",
    },
  };

  const sendNodeStyle = {
    height: "34px",
    margin: "0",
    marginBottom: "25px",
    display:"flex",
    width:"100%",
    alignItems: "center",
    justifyContent: "space-between",
  };

  console.log("radiologist list :", props.radiologistList)
  // let radiologistList = [];
  // props.radiologistList.map((modality) => {
  //   radiologistList.push({
  //     key: modality.id,
  //     text: modality.name,
  //   });
  // });


  const handleClickOutside = () => {
    props.setRadiologistFilteredItems(props.radiologistList)
  };

  const onDropDownSearch = (
    searchValue,
    initialValues
  ) => {
    if (searchValue == null || searchValue == "") {
      return [...initialValues];
    }
    const filteredOptions = [...initialValues].filter(
      (i) => {
        let text = i.text.toLowerCase();
        return text.includes(searchValue.toLowerCase());
      }
    );


    return filteredOptions;
  }

  
  return (
    <>
      {props.loading ? (
        <Spinner size={SpinnerSize.small} styles={customSpinnerStyle} />
      ) : (
        <div className="upload-study-modal-container">
          <div className="container-content">
            {props.radiologistList.length !== 0 ? (
              <>
                <div style={sendNodeStyle}>
                  <div className="ms-sm12 ms-md8 ms-lg6 ms-xl6" style={{flexGrow:"2"}}>
                    <OutsideClickHandler onOutsideClick={handleClickOutside}>
                      <SearchableDropDown
                        dropDownStyle={dropDownStyle}
                        selectedKey={props.selectedRadiologistId}
                        onChange={props.handleDropdownChange}
                        onSearchValueChanged={(searchValue) => {
                          console.log("search value ", searchValue);
                          const newOptions = onDropDownSearch(
                            searchValue,
                            props.radiologistList
                          );
                          props.setRadiologistFilteredItems(newOptions);
                        }}
                        options={
                          props.radiologistFilteredItems.length > 0
                            ? props.radiologistFilteredItems
                            : []
                        }
                        name="pacs node list"
                        className="form-field ms-Grid-col custom-pacs-node-dropdown modal-scroll"
                        style={{ width: "100%" }}
                        label=""
                        placeholder="Select Peer Reviewer"
                       // isMultiSelect={true}
                        isRequired={false}
                      />
                    </OutsideClickHandler>
                  </div>
                  <div className="ms-sm12 ms-md8 ms-lg6 ms-xl2" style={{flexGrow:"1"}}>
                    <PrimaryButton onClick={props.handlePeerReviewAssignment}>
                      Assign
                    </PrimaryButton>
                  </div>
                </div>
              </>
            ) : (
              <p style={noReason}>{props.responseMessage || "No radiologist available"}</p>
            )}
          </div>
        </div>
      )}
    </>
  );
};
